import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapse"
export default class extends Controller {
  static targets = ["gridWrapper", "icon"]
  static values = {
    expanded: { type: Boolean, default: true }
  }

  connect() {
    // Restore state from sessionStorage
    const savedState = sessionStorage.getItem(this.storageKey)
    if (savedState !== null) {
      this.expandedValue = savedState === "true"
    }

    // Set initial state based on screen size if no saved state
    // Collapse by default on mobile/tablet (< 1280px), expanded on desktop
    if (savedState === null && window.innerWidth < 1280) {
      this.expandedValue = false
    }

    this.updateView()
  }

  toggle() {
    this.expandedValue = !this.expandedValue
    sessionStorage.setItem(this.storageKey, this.expandedValue)
    this.updateView()
  }

  updateView() {
    if (this.expandedValue) {
      // Expand: set grid-template-rows to 1fr
      this.gridWrapperTarget.style.gridTemplateRows = "1fr"
      this.iconTarget.classList.remove("rotate-180")
    } else {
      // Collapse: set grid-template-rows to 0fr
      this.gridWrapperTarget.style.gridTemplateRows = "0fr"
      this.iconTarget.classList.add("rotate-180")
    }
  }

  get storageKey() {
    return `collapse-${this.element.dataset.collapseId || "default"}`
  }
}
